
import React, { PureComponent } from 'react';
import firebase from 'firebase'
import { connect } from 'react-redux'
import { Route, BrowserRouter as Router, Redirect, Switch, withRouter } from 'react-router-dom'
import { initFirebase } from 'actions/firebaseInit.js'
import { initIziToast } from 'helpers/iziToast'
import { fetchCoins } from 'actions/listeners/init.js'
import { setUserListener } from 'actions/listeners/user'
import {onMobile} from '../helpers/index';
import ModalsManager from './modalsManager'
import LoadingBar from '../components/loadingBar'
import App from './app'
import Mob from './mob'

initIziToast()

class Container extends PureComponent {
  constructor(props){
    super(props)

    this.state = {
      initialized: false
    }
  }

  logUserIn = (user) => {
    window.loggedIn = true;
    this.props.logIn()
    user.uid === 'B3ZzSz8HgqbB2KZSUo33EwrrAXB2' && this.props.enterAdminMode()
    this.props.setUserListener(user.uid)
    this.props.fetchCoins() // fetch coins freshly again ( without cached as admin )
  }

  logUserOut = () => {
    window.loggedIn = false;
    this.props.logOut()
    this.props.removeUser()
  }

  componentDidMount = () => {
    if(!this.props.firebaseInitialized) {
      this.props.initFirebase() // making sure we initialize Firebase only once...
      this.props.fetchCoins()
      this.setState({ initialized: true })
    }

    firebase.auth().onAuthStateChanged((user) => {
      user
        ? this.logUserIn(user)
        : this.logUserOut()
    })
  }

  render() {

    return (
      this.props.coinsDataStatus !== 'LOADED'
      ? <LoadingBar />
      :
      <fb className="main-frame">
        <Router>
          <Switch>
            <Route path='/app'  component={App} />
            <Route path='/mob'  component={Mob} />
            <Redirect to={onMobile() ? '/mob' : '/app'} />
          </Switch>
        </Router>
        <ModalsManager />
      </fb>
    )
  }
}

const mapDispatchToProps = {
  initFirebase,
  fetchCoins,
  setUserListener,
  logIn: () => ({ type: 'LOG_IN' }),
  logOut: () => ({ type: 'LOG_OUT'}),
  removeUser: () => ({ type: 'remove_user' }),
  enterAdminMode: () => ({ type: 'ENTER_ADMIN_MODE' })
}

const mapStateToProps = (state: Store) => ({
  coinsDataStatus: state.coinsDataStatus,
  firebaseInitialized: state.firebaseInitialized,
})

export default connect(mapStateToProps, mapDispatchToProps)(Container)



// WEBPACK FOOTER //
// ./src/containers/index.js